module.exports = __webpack_public_path__ + "public/img/j7tcntj.f7c64c0a.png";